// extracted by mini-css-extract-plugin
module.exports = {"container":"tabs_container__FycWR","tab-entry":"tabs_tab-entry__XIpeV","tab-entry-bottom":"tabs_tab-entry-bottom__1Stu2","tab-entry-active":"tabs_tab-entry-active__3yBmX"};